import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { toast } from "react-toastify";


export function CambiarContrasenaPage() {
	const onSubmit = (event: React.SubmitEvent) => {
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get("token");

		event.preventDefault();
		const password = (event.target.elements.namedItem("password") as HTMLInputElement).value;
		const repitePassword = (event.target.elements.namedItem("repitePassword") as HTMLInputElement).value;

		if (password != repitePassword) {
			toast("Las contraseñas no coinciden", {type: "warning"});
			return;
		}

		sendAjaxRequest("POST", "/api/v1/cambiarContrasena", {
			password: password,
			repitePassword: repitePassword,
			token: token,
		}).then(() => {
			toast("Contraseña cambiada correctamente", {type: "success"});
			location.href = "/login";
		}).catch((err: unknown) => {
			toast("Error al cambiar la contraseña", {type: "error"});
			console.error(err);
		});
	};

	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
			<title>Piher | Cambiar Contraseña</title>
			<div className="login content-box">
				<div className="biggest-box" style={{ textAlign: "center" }}>
					<img src="/img/logoAlmacen.svg" style={{ width: "auto" }} height="80px" />
				</div>
				<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div style={{ flex: 0.25 }} />
					<div>
						<h4 className="text-center">Introduzca la nueva contraseña</h4>
						<form role="form" className="form" onSubmit={onSubmit}>
							<div className="form-group">
								<input type="password" className="form-control" placeholder="Nueva contraseña" name="password" />
							</div>
							<div className="form-group">
								<input type="password" className="form-control" placeholder="Repite contraseña" name="repitePassword" />
							</div>
							<button type="submit" className="btnPrimary" style={{ width: "100%" }}>
								Cambiar contraseña
							</button>
						</form>
					</div>
					<div style={{ flex: 0.75 }} />
				</div>
			</div>
		</div>
	);
}
